<template>
  <div>
    <NavBar />
    <div class="container">
      <v-btn
        class="v-primary mb-1"
        @click="
          errors = [];
          $bvModal.show('create');
        "
      >
        <span class="fa fa-plus"></span> Novo
      </v-btn>

      <b-overlay :show="loading" opacity="0.99">
        <v-card>
          <v-card-title>
            Tipos de Agendamento
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>

          <v-data-table
            dense
            :headers="headers"
            :items="schedules_types"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [20, 50, 75],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.active`]="{ item }">
              {{ item.active === 1 ? "Ativo" : "Inativo" }}
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>

      <ErrorsMessages :errors="errors" />

      <CreateModal @create="getScheduleType" />

      <UpdateModal
        v-if="schedule_type"
        :schedule_type="schedule_type"
        @update="getScheduleType"
      />
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../templates/components/ErrorsMessages";

import NavBar from "../templates/NavBar";

import api from "../services/api";

import CreateModal from "../templates/Schedule/CreateModal";

import UpdateModal from "../templates/Schedule/UpdateModal";

export default {
  name: "Schedule",

  components: {
    NavBar,
    ErrorsMessages,
    CreateModal,
    UpdateModal,
  },

  data() {
    return {
      errors: [],

      schedules_types: [],

      name: "",

      search: "",

      loading: false,

      schedule_type: null,

      headers: [
        { text: "Nome", sortable: false, value: "name" },
        { text: "Status", sortable: false, value: "active" },
      ],
    };
  },

  async created() {
    await this.getScheduleType();

    this.loading = false;
  },

  methods: {
    handleClickRowTable(item) {
      this.schedule_type = item;
      this.$bvModal.show("update");
    },

    async getScheduleType() {
      try {
        this.loading = true;

        const response = await api.get("/admin/schedule/all");

        const { schedules_types } = response.data;

        this.schedules_types = schedules_types;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>